// Helper type for CSS class strings or arrays of strings
type SlotClassDefinition = string | string[]

// Define slots (ui.props)
interface FormFieldSlots {
	root?: SlotClassDefinition
	wrapper?: SlotClassDefinition
	labelWrapper?: SlotClassDefinition
	label?: SlotClassDefinition
	container?: SlotClassDefinition
	description?: SlotClassDefinition
	error?: SlotClassDefinition
	hint?: SlotClassDefinition
	help?: SlotClassDefinition
}

// Define Variants
interface FormFieldVariants {
	size?: {
		xs?: Partial<FormFieldSlots>
		sm?: Partial<FormFieldSlots>
		md?: Partial<FormFieldSlots>
		lg?: Partial<FormFieldSlots>
		xl?: Partial<FormFieldSlots>
	}
	required?: {
		true?: Partial<FormFieldSlots>
	}
}

export interface ExtendedFormFieldThemeConfig {
	slots?: Partial<FormFieldSlots>
	variants?: Partial<FormFieldVariants>
	defaultVariants?: {
		size?: keyof NonNullable<FormFieldVariants['size']>
		required?: boolean // Assuming 'required' in defaultVariants would be a boolean
	}
}

export default {
	slots: {
		root: '',
		wrapper: '',
		labelWrapper: 'flex content-center items-center justify-between',
		label: 'block font-medium text-default',
		container: 'mt-1 relative',
		description: 'text-muted',
		error: 'mt-1 text-error transition-all duration-200 ease-in',
		hint: 'text-dimmed transition-all duration-200 ease-in',
		help: 'mt-1 text-dimmed'
	},
	variants: {
		size: {
			xs: {
				root: 'text-xs'
			},
			sm: {
				root: 'text-xs'
			},
			md: {
				root: 'text-sm'
			},
			lg: {
				root: 'text-sm'
			},
			xl: {
				root: 'text-base'
			}
		},
		required: {
			true: {
				label: 'after:content-[\'*\'] after:ms-0.5 after:text-error'
			}
		}
	},
	defaultVariants: {
		size: 'md'
	}
} satisfies ExtendedFormFieldThemeConfig
